import React from 'react';
import PropTypes from 'prop-types';
import {useFormik} from 'formik';
import Dialog from '@material-ui/core/Dialog';
import DialogContainer from 'components/DialogContainer/styles';
import DialogTitle from 'components/DialogTitle/styles';
import DialogBody from 'components/DialogBody/styles';
import Subtitle14px from 'components/typography/Subtitle14px';
import {FlexContainer, FlexItem} from 'components/layout';
import AutocompleteField from 'components/AutocompleteField/AutocompleteField';
import FieldInput from 'routes/App/merchants/ActiveUsers/components/FieldInput';
import ButtonPrimary from 'components/buttons/ButtonPrimary/styles';
import {ButtonOutline} from 'components/buttons';
import DialogActions from 'components/DialogActions/styles';
import DialogAction from 'components/DialogAction/styles';
import SudoUserManagementSchema from 'helpers/services/formValidationSchemas/SudoUserManagementSchema';
import {ErrorSign, ErrorSignWrapper} from 'components/errorSign/errorSign';

const NewSudoUserModal = ({onClose, allSudoUserFeatureFlags, createUser}) => {
  const formik = useFormik({
    initialValues: {
      first_name: '',
      last_name: '',
      email: '',
      AllowedFeatures: []
    },
    validationSchema: SudoUserManagementSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      createUser({
        email: values.email?.toLowerCase(),
        first_name: values.first_name,
        last_name: values.last_name,
        AllowedFeatures: values.AllowedFeatures,
        role: 'sudo'
      });
    }
  });

  return (
    <Dialog open scroll='body' onClose={onClose}>
      <DialogContainer className='DialogMd'>
        <DialogTitle className='marginBottom2l'>New User</DialogTitle>
        <DialogBody>
          <Subtitle14px className='mT19'>Email</Subtitle14px>
          <FlexContainer
            justifyContent='space-between'
            className='align-center'
          >
            <FlexItem flex={1} className='relativePosition'>
              <FieldInput
                name='email'
                value={formik.values.email}
                onChange={formik.handleChange}
              />
              <ErrorSignWrapper topPosition='0' leftPosition='0'>
                <ErrorSign>
                  {formik.touched.email && formik.errors.email}
                </ErrorSign>
              </ErrorSignWrapper>
            </FlexItem>
          </FlexContainer>
          <Subtitle14px className='mT19'>First name</Subtitle14px>
          <FlexContainer
            justifyContent='space-between'
            className='align-center'
          >
            <FlexItem flex={1} className='relativePosition'>
              <FieldInput
                name='first_name'
                value={formik.values.first_name}
                onChange={formik.handleChange}
              />
              <ErrorSignWrapper topPosition='0' leftPosition='0'>
                <ErrorSign>
                  {formik.touched.first_name && formik.errors.first_name}
                </ErrorSign>
              </ErrorSignWrapper>
            </FlexItem>
          </FlexContainer>
          <Subtitle14px className='mT19'>Last name</Subtitle14px>
          <FlexContainer
            justifyContent='space-between'
            className='align-center'
          >
            <FlexItem flex={1} className='relativePosition'>
              <FieldInput
                name='last_name'
                value={formik.values.last_name}
                onChange={formik.handleChange}
              />
              <ErrorSignWrapper topPosition='0' leftPosition='0'>
                <ErrorSign>
                  {formik.touched.last_name && formik.errors.last_name}
                </ErrorSign>
              </ErrorSignWrapper>
            </FlexItem>
          </FlexContainer>
          <Subtitle14px className='mB9 mT19'>
            Allowed feature flags
          </Subtitle14px>
          <FlexContainer
            justifyContent='space-between'
            className='align-center'
          >
            <FlexItem flex={1}>
              <AutocompleteField
                multiple
                disableCloseOnSelect
                value={formik.values.AllowedFeatures}
                options={allSudoUserFeatureFlags}
                optionLabelName='id'
                name='AllowedFeatures'
                onChange={(e, value) => {
                  formik.setFieldValue('AllowedFeatures', value);
                }}
              />
            </FlexItem>
          </FlexContainer>
          <DialogActions className='justifyCenter'>
            <DialogAction className='w40'>
              <ButtonOutline type='button' onClick={onClose}>
                <span>Close</span>
              </ButtonOutline>
            </DialogAction>
            <DialogAction className='w40'>
              <ButtonPrimary type='button' onClick={formik.submitForm}>
                <span>Save</span>
              </ButtonPrimary>
            </DialogAction>
          </DialogActions>
        </DialogBody>
      </DialogContainer>
    </Dialog>
  );
};

NewSudoUserModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  allSudoUserFeatureFlags: PropTypes.array.isRequired,
  createUser: PropTypes.func.isRequired
};

export default NewSudoUserModal;
